"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = visitOnce;
function visitOnce() {
  var visited = new Set();
  return function (value) {
    if (visited.has(value)) {
      return false;
    }
    visited.add(value);
    return true;
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ2aXNpdE9uY2UiLCJ2aXNpdGVkIiwiU2V0IiwidmFsdWUiLCJoYXMiLCJhZGQiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9VdGlscy9KU09OTGlua2VkRGF0YS92aXNpdE9uY2UudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdmlzaXRPbmNlPFQ+KCk6ICh2YWx1ZTogVCkgPT4gYm9vbGVhbiB7XG4gIGNvbnN0IHZpc2l0ZWQgPSBuZXcgU2V0PFQ+KCk7XG5cbiAgcmV0dXJuICh2YWx1ZTogVCkgPT4ge1xuICAgIGlmICh2aXNpdGVkLmhhcyh2YWx1ZSkpIHtcbiAgICAgIHJldHVybiBmYWxzZTtcbiAgICB9XG5cbiAgICB2aXNpdGVkLmFkZCh2YWx1ZSk7XG5cbiAgICByZXR1cm4gdHJ1ZTtcbiAgfTtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQWUsU0FBU0EsU0FBU0EsQ0FBQSxFQUE2QjtFQUM1RCxJQUFNQyxPQUFPLEdBQUcsSUFBSUMsR0FBRyxDQUFJLENBQUM7RUFFNUIsT0FBTyxVQUFDQyxLQUFRLEVBQUs7SUFDbkIsSUFBSUYsT0FBTyxDQUFDRyxHQUFHLENBQUNELEtBQUssQ0FBQyxFQUFFO01BQ3RCLE9BQU8sS0FBSztJQUNkO0lBRUFGLE9BQU8sQ0FBQ0ksR0FBRyxDQUFDRixLQUFLLENBQUM7SUFFbEIsT0FBTyxJQUFJO0VBQ2IsQ0FBQztBQUNIIn0=